export type CaptainCopy = {
  heading: string;
  body: string;
};

export const emptyResult = { heading: '', shortHeading: '', body: '' };

export const captainNotProvided = {
  heading: 'captain-options--captain_not_provided-label',
  body: 'captain-options--captain_not_provided-description',
};

export const captainProvided = {
  heading: 'captain-options--captain_provided_in_price-label',
  body: 'captain-options--captain_provided_in_price-description',
};

export const captainSeparate = {
  heading: 'captain-options--independent_captain-label',
  body: 'captain-options--independent_captain-description',
};

const getCaptainedCopy = (captained?: boolean, captainedCost?: boolean): CaptainCopy => {
  if (captained === undefined || captainedCost === undefined) {
    return emptyResult;
  }

  if (!captained) {
    return captainNotProvided;
  }

  return captainedCost
    ? captainProvided
    : captainSeparate;
};

export default getCaptainedCopy;
